<template>
  <div class="centered-container">
    <v-card class="elevation-3">
      <div class="title">
        <img src="/scrapingant-logo.png" />
        <p class="lg--text mb-0 fontweight400">Reset password</p>
        <p class="mb-0 xs--text line-height24 fontweight400" v-if="!success">
          Please, enter email associated with your ScrapingAnt account.
        </p>
      </div>
      <div class="title" v-if="success">
        <p class="mb-0 xs--text line-height24 fontweight400">
          Reset password email has been sent.
        </p>
        <br />
        <p class="mb-0 xs--text line-height24 fontweight400">
          Please, check your email <b>{{ reset_password.email }}</b> for the
          reset password letter.
        </p>
        <br />
        <p class="mb-0 xs--text line-height24 fontweight400">
          <b>Didn't receive the email?</b>
        </p>
        <p class="mb-0 xs--text line-height24 fontweight400">
          Check the <b>spam</b> folder of your email box or try to reset
          password again.
        </p>
      </div>
      <div
        v-if="success"
        class="actions md-layout md-alignment-center-space-between"
      >
        <v-row class="justify-space-between ma-0">
          <v-col class="pa-0">
            <v-btn color="font" :to="{ name: 'Login' }">Login</v-btn>
          </v-col>
          <v-col class="pa-0" align="end">
            <v-btn color="primary" @click="reset_state">Reset</v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-if="!success" class="form" v-on:keyup.enter="resetOnEnter">
        <v-col class="pa-0 mb-6">
          <v-text-field
            v-model="$v.reset_password.email.$model"
            label="E-mail"
            :error-messages="emailErrors"
            @input="$v.reset_password.email.$touch()"
            autofocus
            required
          ></v-text-field>
        </v-col>
        <span class="form-error">{{ error }}</span>
      </div>
      <div v-if="!success" class="actions">
        <v-row class="justify-space-between ma-0">
          <v-col class="pa-0">
            <v-btn color="font" :to="{ name: 'Login' }">Login</v-btn>
          </v-col>
          <v-col class="pa-0" align="end">
            <v-btn color="primary" :disabled="isDisabledForm" @click="reset"
              >Reset</v-btn
            >
          </v-col>
        </v-row>
      </div>
      <div class="loading-overlay" v-if="loading">
        <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
export default {
  name: "ResetPassword",
  data() {
    return {
      loading: false,
      success: false,
      reset_resent: false,
      reset_password: {
        email: "",
      },
      error: "",
    };
  },
  validations: {
    reset_password: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.reset_password.email.$dirty) return errors;
      !this.$v.reset_password.email.email &&
        errors.push("Please, enter correct email");
      !this.$v.reset_password.email.required &&
        errors.push("Please, enter correct email");
      return errors;
    },
    isDisabledForm() {
      return (
        this.$v.reset_password.email.$error ||
        !this.$v.reset_password.email.$dirty
      );
    },
  },
  methods: {
    errors(res) {
      this.error =
        res?.data?.error?.msg ?? "Error occurred. Please, try again.";
    },
    reset() {
      this.loading = true;
      this.$store.dispatch("auth/reset", this.reset_password.email).then(
        () => {
          this.success = true;
          this.loading = false;
        },
        (res) => {
          this.loading = false;
          this.errors(res.response);
        }
      );
    },
    reset_state() {
      this.$router.go();
    },
    resetOnEnter() {
      if (!this.isDisabledForm) {
        this.reset();
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>